/* MEDIA */
export const ADD_UPLOAD = 'ADD_UPLOAD'
export const UPDATE_UPLOAD = 'UPDATE_UPLOAD'
export const UPDATE_MEDIA_UPLOAD = 'UPDATE_MEDIA_UPLOAD'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
export const UPLOAD_MEDIA_SUCCESS = 'UPLOAD_MEDIA_SUCCESS'
export const REMOVE_UPLOAD = 'REMOVE_UPLOAD'
export const REMOVE_MEDIA_UPLOAD = 'REMOVE_MEDIA_UPLOAD'
export const UPLOAD_ERROR = 'UPLOAD_ERROR'
